export const Playlist = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Playlist</h1>
        </div>
    )
}